export const makeOptions = <
  Pairs extends readonly [string, string][]
>(optionPairs: Pairs) => {
  type Value = Pairs[number][0];
  type Label = Pairs[number][1];

  const options = optionPairs.map(([value, label]) => ({ value, label }));

  const namings = Object.fromEntries(optionPairs) as Record<Value, Label>;
  const reverseNaming = Object.fromEntries(
    optionPairs.map(([v, l]) => [l, v])
  ) as Record<Label, Value>;

  return {
    options,
    namings,
    reverseNaming,
  };
};

export const { namings: upliftNamings } = makeOptions([
  ["N", "Not Started"],
  ["Y", "Complete"],
  ["P", "In Progress"],
]);

export const UpliftStatus = {
  N: "N",
  Y: "Y",
  P: "P",
} as const;

export const RestrictionStatus = {
  None: "None",
  UPLR: "UPLR",
  UPLF: "UPLF",
} as const;

export const { namings: RestrictionStatusNaming } = makeOptions([
  ["None", "Not Started"],
  ["UPLR", "Money Out"],
  ["UPLF", "Money In and Out"],
]);

export const ConsiderationStatus = {
  RI: "RI",
  RC: "RC",
  PCLS: "PCLS",
} as const;

export const { namings: ConsiderationStatusNaming } = makeOptions([
  ["RI", "Regular Income"],
  ["RC", "Regular Contributions"],
  ["PCLS", "Pension Commencement Lump Sum"],
]);
